var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrainHistory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 14,
    viewBox: "0 0 64 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearHistory",
    x1: 31.5844,
    y1: 1.89583,
    x2: 31.6356,
    y2: 14.0015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F3DB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.260313,
    stopColor: "#2345CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#355AEE"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.9962 0H36.0077H27.9923H18.0038H3.87694C1.91446 0 0.48045 1.85319 0.972952 3.75287L3.04699 11.7529C3.39002 13.076 4.5841 14 5.95099 14H18.0038H31.6219H32.3781H45.9962H58.049C59.4159 14 60.61 13.076 60.953 11.7529L63.0271 3.75288C63.5196 1.8532 62.0855 0 60.1231 0H45.9962Z",
    fill: "url(#linearHistory) rgba(53,90,238,1)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainHistory);
export default __webpack_public_path__ + "static/media/trainHistory.8bda0acb.svg";
export { ForwardRef as ReactComponent };